// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { render, createElement, LocaleProvider } from '@plesk/ui-library';
import LicenseStatus from './LicenseStatus';

module.exports = ({ container, locale, ...props }) => {
    render((
        <LocaleProvider messages={locale}>
            <LicenseStatus {...props} />
        </LocaleProvider>
    ), container);
};



// WEBPACK FOOTER //
// ./app/license-status/index.js